import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery, useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery, } from "../../../../app/services/SelfEvaluationForm/selfEvalutionServiceApi";
import { useLazyGetProductsListByProductInformationIdQuery } from "../../../../app/services/productAndService/productAndServiceApi";
import { decryptAESID } from "../../../../utils/Encryption";
import { useSectionRequirements } from "../../utils/useSectionRequirement";
import RequirementCard from "../../utils/RequirementCard";
import NoRecordFound from "../../../../components/ui/noRecordFound/NoRecordFound";

const SECTION = "B";

const SectionB = () => {
    const { id } = useParams();
    const [brandList, setBrandList] = useState([]);

    const { state, record, fieldList, handlePeerReviewerComment, handleClarificationSend, isFieldInvalid, saveLoading } =
        useSectionRequirements(
            SECTION,
            useLazyGetRequirementListForSectionBBySGBPApplicationIdQuery,
            useLazyGetRequirementAdditionalInputFieldForSectionBBySGBPApplicationIdQuery
        );
    const [getProductsList, { data: productsData, isLoading: productsLoading }] = useLazyGetProductsListByProductInformationIdQuery();

    useEffect(() => {
        const applicationId = decryptAESID(id?.toString(), false);
        if (applicationId) getProductsList(applicationId);
    }, [id]);

    useEffect(() => {
        if (!productsLoading && productsData) {
            const mapped = productsData
                .filter((item) => item.brandName != null)
                .map((item) => ({
                    id: item.sgbpProductDetailsId,
                    brand: item.brandName,
                    model: item.modelName,
                }));
            setBrandList(mapped);
        }
    }, [productsLoading, productsData]);

    return (
        <div className="section-card">
            <h3 className="section-title">Section 2</h3>
            {record.length > 0 ? (
                <>
                    <div className="evaluation-table-wrapper">
                        {record.map((item) => {
                            const reqId = item.sgbpRequirementId;
                            const reqData = state?.sections?.[SECTION]?.requirements?.[reqId] || { files: [], comment: "" };
                            const matchedFields = fieldList.filter((f) => f.sgbpRequirementId === reqId);

                            return (
                                <RequirementCard
                                    key={reqId}
                                    item={item}
                                    reqData={reqData}
                                    matchedFields={matchedFields}
                                    brandList={brandList}
                                    fieldsState={state.sections?.[SECTION]?.fields}
                                    isFieldInvalid={isFieldInvalid}
                                    caseOfficerComments={reqData.caseOfficerComments}
                                    peerReviewerComments={reqData.peerReviewerComments}
                                    status={reqData.status}
                                    onCommentChange={(val) => handlePeerReviewerComment(reqId, val)}
                                    onSave={() => handleClarificationSend(reqId)}
                                    saveLoading={saveLoading}
                                    extraClass="custom-evalution-table"
                                />
                            );
                        })}
                    </div>
                    <div className="sectionC-info">
                        <div className="rating-box">
                            {/* <h4>Rating</h4> */}
                            <div className="sectionC-header">
                                <h3 className="sectionC-title" >Section 2 Minimum Criteria: <input
                                    type="text"
                                    className="rating-input"
                                    value={state?.sectionBMinCriteria}
                                    disabled
                                // onChange={(e) => onServiceMinCriteriaChange(e.target.value)}
                                />
                                    <span className="rating-total">/{record?.length || "N.A"}</span></h3>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <NoRecordFound />
            )}
        </div>
    );
};

export default SectionB;